import React from "react"

import { PrimaryButton } from "components/buttons"
import { useSignOut } from "hooks/useSignOut"
import { baseRoutes } from "routes"

import { DropdownMenu } from "./styles"
import { TEST_MARKER_CONSTANTS } from "shared/test-selectors"

const DROPDOWN_LINKS = [
  { id: 1, title: "My Dashboard", to: baseRoutes.dashboard(), dataTest: TEST_MARKER_CONSTANTS.RIGHT_MENU_DASHBOARD },
  { id: 2, title: "My Account", to: baseRoutes.userEdit(), dataTest: TEST_MARKER_CONSTANTS.RIGHT_MENU_USER_EDIT },
  {
    id: 3,
    title: "Refer a Friend",
    to: baseRoutes.referral(),
    dataTest: TEST_MARKER_CONSTANTS.RIGHT_MENU_REFER_FRIEND
  },
  { id: 4, title: "Legals", to: baseRoutes.legals(), dataTest: TEST_MARKER_CONSTANTS.RIGHT_MENU_LEGALS }
]

const RightDropdownMenu: React.FC<{ handleClose: () => void }> = ({ handleClose }) => {
  const { signOut, loading } = useSignOut()

  const handleSignOut = () => {
    signOut()
    handleClose()
  }

  return (
    <DropdownMenu.Container>
      <DropdownMenu.List>
        {DROPDOWN_LINKS.map(({ id, title, to, dataTest }) => (
          <DropdownMenu.Item key={id} onClick={handleClose} data-test={dataTest}>
            <DropdownMenu.Link to={to}>{title}</DropdownMenu.Link>
          </DropdownMenu.Item>
        ))}

        <DropdownMenu.Item mt={4}>
          <PrimaryButton onClick={handleSignOut} sizing="stretch" disabled={loading} loading={loading}>
            Log out
          </PrimaryButton>
        </DropdownMenu.Item>
      </DropdownMenu.List>
    </DropdownMenu.Container>
  )
}

export default RightDropdownMenu
